import React from 'react';
import { LogOut, ChevronRight } from 'lucide-react';

const Navbar = ({ onLogout, activeLabel, ActiveIcon, activeColorClass, drilldownSource }) => (
  <nav className="relative w-full bg-white border-b border-slate-200 px-6 py-3 shadow-sm flex justify-between items-center">
    {/* Logo — left anchor */}
    <div className="flex items-center gap-3 flex-shrink-0">
      <img src="https://smgba.com/misc/images/logos/SMGIconWhite.png" alt="SMG Logo" className="h-8 w-auto object-contain" />
      <h1 className="text-lg font-bold text-slate-800 tracking-tight">Staff<span className="text-blue-600">Hub</span></h1>
    </div>

    {/* Centered page title — absolutely positioned so it's always truly centred */}
    <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 pointer-events-none select-none">
      {drilldownSource && (
        <>
          <span className="text-xs text-slate-400 font-medium">{drilldownSource}</span>
          <ChevronRight className="w-3.5 h-3.5 text-slate-300 flex-shrink-0" />
        </>
      )}
      {ActiveIcon && activeColorClass && (
        <div className={`p-1.5 rounded-lg flex-shrink-0 ${activeColorClass}`}>
          <ActiveIcon className="w-4 h-4 text-white" />
        </div>
      )}
      {activeLabel && (
        <span className="text-sm font-bold text-slate-800 tracking-tight whitespace-nowrap">{activeLabel}</span>
      )}
    </div>

    {/* Logout — right anchor */}
    <button onClick={onLogout} className="flex items-center gap-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 px-3 py-1.5 rounded-md transition-colors text-xs font-medium border border-transparent hover:border-red-100 flex-shrink-0">
      <LogOut className="w-4 h-4" /> Logout
    </button>
  </nav>
);
export default Navbar;